import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router'
import { Card, Container, Row, Col, Form, Button } from 'react-bootstrap'
import { GetCollection, GetUser } from '../../../firebase/firebase'
import { useAuth } from '../../../contexts/AuthContext'
import Spinner from 'react-spinkit'
import RecipeCategories from '../RecipeCategories/RecipeCategories'
export const AdminHomeWrapper = (props) => {
    const { path } = props.match


    return (
        <>
            <Row>
                <Col sm={3}>
                    <AdminNav match={props.match} />
                </Col>
                <Col sm={9}>
                    <AdminDashboard />
                </Col>
            </Row>
            <Row>
                <RecipeCategories />
            </Row>
        </>
    )
}
const BlogsCard = (props) => {
    const [blogs, setBlogs] = useState([])
    useEffect(() => {
        GetCollection('blogPosts', false).then((data) => {
            setBlogs(data.docs.map((doc) => doc.data()))
        })
        console.log('readblogs')
    }, [])
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        Blogs
                    </Card.Header>
                    {blogs && blogs.map((blog, idx) => {
                        return (
                            <>
                                <Row key={idx}>
                                    <Link to={`admin/editblog/${blog.id}`}>{blog.title}</Link>
                                </Row>
                            </>
                        )
                    }

                    )}
                </Card.Body>
            </Card>
        </>
    )
}
const UsersCard = (props) => {
    const [users, setUsers] = useState([])
    useEffect(() => {
        GetCollection('users', false).then((data) => {
            setUsers(data.docs.map((doc) => doc.data()))
        })
        console.log('read users again')
    }, [])
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        Users
                    </Card.Header>
                    <Row>
                        Total Users: {users.length}
                    </Row>
                    <Row>
                        Admins: {users.filter(user => user.role.includes('admin')).length}
                    </Row>

                </Card.Body>
            </Card>
        </>
    )
}

const AdminDashboard = (props) => {
    return (
        <>
            <Card>
                <Card.Body>
                    <Card.Header>
                        Dashboard
                    </Card.Header>
                    <Row>
                        <Col md={4}>
                            <UsersCard />
                        </Col>
                        <Col md={8}>
                            <BlogsCard />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

        </>
    )
}

const AdminNav = (props) => {
    const { path } = props.match
    const { currentUser, logout, userRole } = useAuth()
    const [user, setUser] = useState('')
    const [loading, setLoading] = useState(false)
    const [validated, setValidated] = useState(false)
    const history = useHistory()
    const [image, setImage] = useState('')



    useEffect(() => {
        GetUser(currentUser.uid).then((user) => {
            setUser(user.data())
        })
        console.log("read users")
    }, [])


    return (

        <>

            <Card>
                <Card.Body>
                    <Card.Header>
                        {user.firstName + ' ' + user.lastName}
                    </Card.Header>
                    <Row>
                        <Link to={`${path}/createBlogPost`}>Create Blog Post</Link>
                    </Row>
                    <Row>
                        <Link to={`${path}/addRecipe`}>Add Recipe </Link>
                    </Row>
                    <Row>
                        <Link to={`${path}/addTikTok`}>Add Tik Tok </Link>
                    </Row>

                    {user.adminType === 'superAdmin' ?
                        <Row>
                            <Link to={`${path}/surveyData`}>Survey Data </Link>
                        </Row>
                        : ""}
                </Card.Body>
            </Card>
        </>
    )
}
